import React, { useState } from 'react';
import { Clock, ChevronDown, ChevronUp, Plus } from 'lucide-react';

const TaskPanel = () => {
  const [tasks, setTasks] = useState([
    {
      id: 't1',
      priority: 'high',
      etaMinutes: 60,
      title: 'Finish Interview with Mary',
      subtasks: ['Send feedback to team', 'Introductory analysis'],
      expanded: false
    },
    {
      id: 't2',
      priority: 'medium',
      etaMinutes: 20,
      title: 'Finish Quest draft',
      subtasks: ['Answer questions'],
      expanded: false
    },
    {
      id: 't3',
      priority: 'low',
      etaMinutes: 10,
      title: 'Reply to messages',
      subtasks: ['Reply to Richard'],
      expanded: false
    }
  ]);

  const [newTaskInput, setNewTaskInput] = useState('');

  const toggleTask = (taskId) => {
    setTasks(tasks.map(task => 
      task.id === taskId ? { ...task, expanded: !task.expanded } : task
    ));
  };

  const addTask = () => {
    if (newTaskInput.trim()) {
      const newTask = {
        id: `t${tasks.length + 1}`,
        priority: 'medium',
        etaMinutes: 30,
        title: newTaskInput,
        subtasks: [],
        expanded: false
      };
      setTasks([...tasks, newTask]);
      setNewTaskInput('');
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return '#FF3B30';
      case 'medium': return '#FF9500';
      case 'low': return '#34C759';
      default: return '#007AFF';
    }
  };

  return (
    <div className="panel task-panel">
      <h2 className="panel-title">Today's Tasks</h2>
      
      <div className="tasks-list">
        {tasks.map((task) => (
          <div key={task.id} className="task-item">
            <div className="task-header" onClick={() => toggleTask(task.id)}>
              <div className="task-left">
                <div 
                  className="task-priority-indicator"
                  style={{ backgroundColor: getPriorityColor(task.priority) }}
                />
                <div className="task-main">
                  <h4 className="task-title">{task.title}</h4>
                  <div className="task-meta">
                    <Clock size={14} />
                    <span>{task.etaMinutes} min</span>
                    <span className="task-priority-label">{task.priority}</span>
                  </div>
                </div>
              </div>
              <button className="task-expand-btn">
                {task.expanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </button>
            </div>
            
            {task.expanded && task.subtasks.length > 0 && (
              <div className="task-subtasks">
                {task.subtasks.map((subtask, index) => (
                  <div key={index} className="subtask-item">
                    <input type="checkbox" className="subtask-checkbox" />
                    <span>{subtask}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="task-input-container">
        <input
          type="text"
          placeholder="What's on the to-do list today?"
          value={newTaskInput}
          onChange={(e) => setNewTaskInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && addTask()}
          className="task-input"
        />
        <button onClick={addTask} className="add-task-btn">
          <Plus size={20} />
        </button>
      </div>
    </div>
  );
};

export default TaskPanel;
